import { render, staticRenderFns } from "./KonfigurasiAktivitas.vue?vue&type=template&id=ec5df968&scoped=true&lang=html&"
import script from "./KonfigurasiAktivitas.vue?vue&type=script&lang=js&"
export * from "./KonfigurasiAktivitas.vue?vue&type=script&lang=js&"
import style0 from "./KonfigurasiAktivitas.vue?vue&type=style&index=0&id=ec5df968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5df968",
  null
  
)

export default component.exports